import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { DiscussionEditorComponent } from "./discussion-editor.component";
import { EditableDiscussionResolver } from "../../../shared/services";
import { AuthGuard } from "../../../shared";

const routes: Routes = [
  {
    path: "", // path is "editor"
    component: DiscussionEditorComponent,
    canActivate: [AuthGuard],
    data: {
      title: "nDaba | Discussion Creator",
      icon: "ti-layout-sidebar-left",
      caption: "Create your new nDaba | discussion",
      status: true,
    },
  },
  {
    path: ":discussion",
    component: DiscussionEditorComponent,
    canActivate: [AuthGuard],
    resolve: {
      discussion: EditableDiscussionResolver,
    },
    data: {
      title: "Discussion Editor",
      icon: "ti-layout-sidebar-left",
      caption: "Edit your discussion here",
      status: true,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DiscussionEditorRoutingModule {}
